export default "__VITE_ASSET__BbjK71zV__"